<template>
	<div class="col-12 inMiddle-area table-responsive">
		<table class="table customize">
			<thead>
				<tr>
					<th>{{$t('dw_acc_fund_accountId')}}</th>
					<th>{{$t('dash_currency')}}</th>
					<th>{{$t('dash_Platform')}}</th>
					<th>{{$t('Dlist_demoLive')}}</th>
					<th>{{$t('Dlist_accountType')}}</th>
					<th>{{$t('Dlist_leverage')}}</th>
					<th></th> 
				</tr>
			</thead>
			<account-list-table v-if="(!pageLoader1 && liveAccountList != '' && liveAccountList.totalRecords > 0)" :accountlist="liveAccountList.records" :pageLoader="pageLoader1" :listType="'managed'"/>
			<loader-component :pageloader_value="pageLoader1" :type="'table'" :colspan="col_span" :list="liveAccountList" v-else></loader-component>
		</table> 
		<!--<pagination :getList="manageAccountList" :limit="pageLimit" v-if="manageAccountList.totalRecords > 0"></pagination>-->
	</div>
</template>
<script>
	import account_list_table from '../shared/tradingAccounts/account-list-table'
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'Live-Account-List',
        mixins: [fxViewMixins],
        data() {
            return { 
                //===========prop in loader component=======
                col_span : 7,
				showButtonDetailInfo : ''
            }
        },
		props:['pageLoader1'],
		components: {
            accountListTable : account_list_table
        },
        methods:{
        	detailDiv(index,getData,account_id,act_account_id) {
				if(getData == 'div'){
					var element = document.getElementById(getData+index)
					if ($(element).hasClass('hide')){
						$(element).removeClass('hide');
					}else{
						$(element).addClass('hide');
					} 
				}else{
					if(parseInt(this.showButtonDetailInfo) == index){
						this.showButtonDetailInfo = ''
					}else{
						this.showButtonDetailInfo = index
					}
				}
            },
        	
		},
		mounted() { 
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.dotAreaForButton').length){
                    _that.showButtonDetailInfo = ''
                }
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/managed_account_list.vue